var _g, _circle, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12962_133241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4598 27.6854C27.9438 26.3312 28.0805 24.8514 28.7798 23.5851L30.384 20.6799C33.0988 15.7634 31.4542 9.41182 26.6533 6.66367C24.2696 5.34741 21.4667 4.96619 18.8485 5.65894C16.1891 6.42619 13.9456 8.20071 12.6293 10.5844L10.9017 13.7131C10.2025 14.9795 9.0229 15.8834 7.60204 16.1681C6.48692 16.4272 5.64645 17.4212 5.55867 18.6363C5.5198 19.5869 6.05128 20.5608 6.94518 21.0544L24.5997 30.803C25.4936 31.2966 26.601 31.2276 27.3848 30.6884C28.441 30.0079 28.7933 28.8416 28.4598 27.6854ZM26.4886 29.3187C26.2162 29.4599 25.7949 29.5188 25.4969 29.3543L7.84233 19.6057C7.54437 19.4412 7.25417 19.0866 7.34421 18.7475C7.4009 18.2927 7.68105 17.9614 8.02793 17.8613C9.8368 17.4021 11.4455 16.2491 12.3916 14.5358L14.1192 11.4071C15.2298 9.39583 17.0775 7.986 19.2744 7.35219C21.4713 6.71837 23.7449 7.00178 25.6817 8.07124C25.7562 8.11238 25.7562 8.11238 25.8307 8.15351C29.8121 10.4492 31.1976 15.6857 28.853 19.9317L27.2488 22.8369C26.3439 24.4757 26.1839 26.5259 26.7587 28.3014C26.9333 28.6894 26.8021 29.103 26.4886 29.3187ZM18.7839 28.6608C18.4937 28.3062 17.9233 28.2828 17.5687 28.573C16.6203 29.4103 15.2818 29.546 14.1644 28.929C13.047 28.312 12.4488 27.1068 12.6522 25.8583C12.7089 25.4035 12.3853 24.9333 11.9306 24.8766C11.4759 24.8199 11.0056 25.1434 10.9489 25.5982C10.6399 27.5661 11.5873 29.5472 13.3006 30.4933C15.0139 31.4393 17.1952 31.1858 18.6961 29.876C19.0919 29.5113 19.1152 28.941 18.7839 28.6608Z",
    fill: "#525559"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 12.5,
    r: 9.5,
    fill: "url(#paint0_radial_12962_133241)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 12.5,
    r: 6.5,
    fill: "#FF6262"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12962_133241",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5 12.5) rotate(90) scale(9.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB8A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12962_133241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.23,
    height: 27.23,
    fill: "white",
    transform: "translate(14.5854) rotate(28.9068)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRed);
export default __webpack_public_path__ + "static/media/notification_red.d377e6d014c21fc424bc2513457a4581.svg";
export { ForwardRef as ReactComponent };